import { Component, OnInit, Input, OnChanges } from '@angular/core';
import moment from 'moment';
import { FiltersModel, CustomerModel } from '@kanzi-apes/kanzi-models';

@Component({
    selector: 'lib-kanzi-printed-items-count',
    templateUrl: './kanzi-printed-items-count.component.html',
    styleUrls: ['./kanzi-printed-items-count.component.scss'],
    standalone: false
})
export class KanziPrintedItemsCountComponent implements OnInit, OnChanges {
  @Input() customer!: CustomerModel | null;

  today: number = 0;
  description1: string = '';
  description2: string = '';
  description3: string = '';
  type1: string = '';
  type2: string = '';
  type3: string = '';
  path: string = '';
  filter1!: FiltersModel;
  filter2!: FiltersModel;
  filter3!: FiltersModel;
  monthName: string = '';

  constructor() {}
  ngOnInit() {}
  ngOnChanges() {
    this.monthName = moment(new Date()).startOf('month').format('MMMM');
    this.description1 = 'Hoy';
    this.description2 = `Total ${this.monthName}`;
    this.description3 = 'Total';
    this.type1 = 'warning';
    this.type2 = 'primary';
    this.type3 = 'success';
    if (this.customer) {
      this.path = 'inventory/traces/';
      this.today = Date.now();
      const today = moment().format('YYYY-MM-DD');
      const minDate = moment(new Date()).startOf('month').format('YYYY-MM-DD');
      const maxDate = moment(new Date()).endOf('month').format('YYYY-MM-DD');
      // this.filter1 = {
      //   customer_id: this.customer.id,
      //   page: 1,
      //   page_size: 1,
      //   action: 'PRINT',
      //   created: today,
      // };
      this.filter2 = {
        customer_id: this.customer.id,
        page: 1,
        page_size: 1,
        action: 'PRINT',
        created_min: minDate,
        created_max: maxDate,
      };
      this.filter3 = {
        customer_id: this.customer.id,
        page: 1,
        page_size: 1,
        action: 'PRINT',
      };
    } else {
      this.path = 'inventory/traces/';
      this.today = Date.now();
      const today = moment().format('YYYY-MM-DD');
      const minDate = moment(new Date()).startOf('month').format('YYYY-MM-DD');
      const maxDate = moment(new Date()).endOf('month').format('YYYY-MM-DD');
      // this.filter1 = {
      //   page: 1,
      //   page_size: 1,
      //   action: 'PRINT',
      //   created: today,
      // };
      this.filter2 = {
        page: 1,
        page_size: 1,
        action: 'PRINT',
        created_min: minDate,
        created_max: maxDate,
      };
      this.filter3 = {
        page: 1,
        page_size: 1,
        action: 'PRINT',
      };
    }
  }
}
